import { LoadUserLocationList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '../protocols/http'

export class RemoteLoadUserLocationList implements LoadUserLocationList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadUserLocationList.Response>
  ) {}

  async load(params?: LoadUserLocationList.Params): Promise<LoadUserLocationList.Model[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        q: params?.searchText,
        resource_place_ids: params?.resourcePlaces,
        form_ids: params?.forms,
        project_ids: params?.projects,
        provider_ids: params?.providers,
        inspector_ids: params?.inspectors,
        status: params?.status,
        work_finish_option_ids: params?.finishOptions
      }
    })
    const locations = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatLocations(locations)
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadUserLocationList {
  export type Location = {
    user_id: number;
    complete_name?: string;
    email: string;
    profile_image_url?: string;
    latitude: string;
    longitude: string;
    accuracy?: number;
    last_locale_at: string;
    recent_work_id?: number;
    recent_work_name?: string;
  }
  export type Response = {
    user_locations?: Location[]
  }
}


const formatLocations = (locations: RemoteLoadUserLocationList.Response): LoadUserLocationList.Model[] => {
  return locations?.user_locations?.map(location => ({
    id: location.user_id,
    name: location.complete_name,
    email: location.email,
    photoUrl: location.profile_image_url,
    latitude: location.latitude,
    longitude: location.longitude,
    accuracy: location.accuracy,
    lastSeenAt: location.last_locale_at,
    description: location.recent_work_name
  })) || []
}
